<template>
    <div class="row">
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 offset-xs-1 offset-md-0 offset-lg-2 mt-xs-3 pt-sm-3 mt-sm-3 pt-sm-3">
            <span class="title">Zu meiner Person</span>
            <p class="mt-5">Seit 2007 bin ich Rechtsanwalt. Zunächst war ich Partner einer Rechtsanwaltsgesellschaft in Dortmund.</p>
            <p>Sodann habe ich mich in eigener Kanzlei in Bochum niedergelassen. </p>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-4 offset-md-1 center-sm mt-sm-30 mt-sm-3 pt-sm-3">
            <img alt="Rechtsanwalt Christ" src="../assets/portrait-rechtsanwalt-christ.jpg">
        </div>

    </div>
</template>

<script>
    export default {
        name: "AboutMe.vue"
    }
</script>

<style scoped>

</style>